import { Box, Select, Option, Typography } from "@mui/joy";
import { useEffect, useState } from "react";
import { Maximize2 } from "lucide-react";

interface ISkylightSize {
    value: string | null;
    onChange: (value: string) => void;
    loading?: boolean;
}

export function SkylightSize(props: ISkylightSize) {
    const { value, onChange, loading } = { ...props };
    const [skylightSize, setSkylightSize] = useState<string | null>(null);

    const handleUpdate = (event: any, newValue: string | null) => {
        if (loading) return;
        const selectedValue = newValue || "";
        setSkylightSize(selectedValue);
        onChange(selectedValue);
    };

    useEffect(() => {
        if (value) {
            setSkylightSize(value);
        }
    }, [value]);

    return (
        <Box flex={1}>
            <Typography level="body-sm" sx={{ fontWeight: "md", mb: 0.5 }}>
                Skylight Size
            </Typography>

            <Select
                placeholder="Select skylight size"
                value={skylightSize}
                onChange={handleUpdate}
                disabled={loading}
                startDecorator={<Maximize2 size={16} />}
                slotProps={{ listbox: { sx: { zIndex: 10001 } } }}
            >
                <Option value="None">None</Option>
                <Option value="Small (<6.6 sf)">Small (&lt;6.6 sf)</Option>
                <Option value="Medium (6.6-9 sf)">Medium (6.6–9 sf)</Option>
                <Option value="Large (9.1-10 sf)">Large (9.1–10 sf)</Option>
            </Select>
        </Box>
    );
}
